// ─────────────────────────────────────────────────────────────────────────────
// badges.js — presentational atoms shared across the Users page.
//   StatusBadge + the status color config, consumed by the table (the pill) and
//   the toolbar (the status-filter chips).
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./badges.module.css";

// Status values are lowercase from the API: 'active' | 'offline' | 'blocked'
// Figma palette: Active = green #00FFA3; Offline & Blocked = red #FF6467.
export const STATUS_CONFIG = {
  active:  { label: "Active",  color: "#00FFA3", bg: "rgba(0,255,163,0.10)" },
  offline: { label: "Offline", color: "#FF6467", bg: "rgba(251,44,54,0.10)" },
  blocked: { label: "Blocked", color: "#FF6467", bg: "rgba(251,44,54,0.10)" },
};

// ── Status pill ──────────────────────────────────────────────────────────────
export function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.offline;
  return (
    <span className={styles.badge} style={{ color: cfg.color, background: cfg.bg }}>
      <span className={styles.dot} style={{ background: cfg.color }} />
      {cfg.label}
    </span>
  );
}
